import script from "./EvalResults.vue?vue&type=script&setup=true&lang=js"
export * from "./EvalResults.vue?vue&type=script&setup=true&lang=js"

import "./EvalResults.vue?vue&type=style&index=0&id=48c80ed4&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48c80ed4"]])

export default __exports__